module.exports = __webpack_public_path__ + "img/huawei_icon_active.0967aa2e.png";